import { Button, DialogActions, DialogContent, Divider, Typography } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack } from '@mui/system';
import { Trans } from 'react-i18next';

interface ProjectSavedDialogProps {
  onClose: () => void;
  open: boolean;
  projectName?: string;
}

const ProjectSavedDialog = ({ onClose, projectName }: ProjectSavedDialogProps) => {
  return (
    <>
      <DialogTitle variant="sectionTitle" align="center">
        <Trans i18nKey="projectSavedDialog.title">Project Saved</Trans>
      </DialogTitle>
      <Divider />
      <DialogContent style={{ padding: '3rem 2.75rem' }}>
        <Stack direction="column" spacing={2} useFlexGap flexWrap="wrap">
          <Typography variant="body1">
            <Trans i18nKey="projectSavedDialog.body">{{ projectName }} has been saved to your projects.</Trans>
          </Typography>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions style={{ justifyContent: 'center', margin: '2px 0' }}>
        <Button variant="contained" autoFocus onClick={onClose}>
          <Trans i18nKey="button.close">Close</Trans>
        </Button>
      </DialogActions>
    </>
  );
};

export default ProjectSavedDialog;
